import { useQuery as e } from "@tanstack/react-query";
//#region src/hooks/useQuery.ts
function t(t) {
	return e(t);
}
//#endregion
export { t as useQuery };
